/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_3_AInputs */

const en_mk_faq_3_a = /** @type {(inputs: Mk_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the local CLI workflow, sync sends metadata and agent-prepared summaries. In Automatic mode, project code is built and stored in Bystep’s server environment for preview and publishing. Context sent to AI providers depends on your chosen workflow and connection.`)
};

const id_mk_faq_3_a = /** @type {(inputs: Mk_Faq_3_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pada alur CLI lokal, sinkronisasi mengirim metadata dan ringkasan yang disiapkan agent. Pada mode Otomatis, kode proyek dibangun dan disimpan di lingkungan server Bystep untuk pratinjau dan penerbitan. Konteks yang dikirim ke penyedia AI mengikuti alur dan koneksi yang kamu pilih.`)
};

/**
* | output |
* | --- |
* | "In the local CLI workflow, sync sends metadata and agent-prepared summaries. In Automatic mode, project code is built and stored in Bystep’s server environme..." |
*
* @param {Mk_Faq_3_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_3_a = /** @type {((inputs?: Mk_Faq_3_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_3_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_3_a(inputs)
	return en_mk_faq_3_a(inputs)
});